<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('costs') }} </h1>  
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li> 
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>      
                    <li class="breadcrumb-item text-gray-600">{{ $t('create_costs') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li>   
                </ul> 
            </div>  
            <div class="d-flex align-items-center py-1">
                <router-link to="/Settings">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> {{ $t('return_back_to_settings') }} </span>
                    </button>
                </router-link> 
            </div>
        </div>
        <div class="content flex-row-fluid mt-4" id="kt_content">
            <RequiredField></RequiredField>
            <div class="card card-xxl-stretch">
                <div class="row p-10">
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                            <div class="card-body pb-0">
                                <form id="kt_ecommerce_settings_general_form"
                                    class="form fv-plugins-bootstrap5 fv-plugins-framework">
                                    <div class="fv-row mb-7 row">
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                {{ $t('cost_of_sales') }}
                                            </label>
                                            <Select2 v-model="form.cost_of_sales" :options="costOfSalesList" :settings="{ width: '100%' }"/> 
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                {{ $t('cost_of_sales_method') }}
                                            </label>
                                            <Select2 v-model="form.cost_of_sales_method" :options="costOfSalesMethodList" :settings="{ width: '100%' }"/> 
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6">
                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                            <div class="card-body pb-0">
                                <form id="kt_ecommerce_settings_general_form"
                                    class="form fv-plugins-bootstrap5 fv-plugins-framework">
                                    <div class="fv-row mb-7 row">
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                 {{ $t('cost_of_production') }}  
                                            </label>
                                            <Select2 v-model="form.cost_of_production" :options="costOfProductionList" /> 
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                 {{ $t('cost_of_production_method') }} 
                                            </label>
                                            <Select2 v-model="form.cost_of_production_method" :options="costOfProductionMethodList" /> 
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-lg-12">
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-success" @click="this.saveData()" data-kt-indicator="on">
                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                </svg>
                                </span> 
                                <strong v-if="!this.isProgressing"> {{ $t('save_cost_method') }}</strong> 
                                    <span class="indicator-progress" v-if="this.isProgressing">
                                        {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span> 
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import axios from 'axios' 

 
export default {
  name: "CostSettings", 
  data() {
    return {
      searchbar: '',
      branchList: [],
      isProgressing: false,
      form:{
        cost_of_sales: 1,
        cost_of_sales_method: 1,
        cost_of_production: 1,
        cost_of_production_method: 1,
      },
      costOfSalesList: [
        { id: 1, text: this.$t('apply')},
        { id: 0, text: this.$t('not_apply')},
      ],
      costOfSalesMethodList: [
        { id: 1, text: this.$t('first_in_first_out')},
        { id: 2, text: this.$t('moving_average_cost')}, /* hareketli ağırlıklı ortalama maliyet */
      ],
      costOfProductionList: [
        { id: 1, text: this.$t('apply')},
        { id: 0, text: this.$t('not_apply')},
      ],
      costOfProductionMethodList: [
        { id: 1, text: this.$t('first_in_first_out')},
        { id: 2, text: this.$t('moving_average_cost')}, /* hareketli ağırlıklı ortalama maliyet */
      ],
      menuSelection: '/CostsManagementHelppage',
      iconView : false
    };
  },
  methods: {
    getData() { 
      const params = {
        session_id: this.$getUser().session_id
      };
      axios.post('/api/CostsSettings/GetCostSettings', params, {'Content-Type': 'application/json'})
        .then((response) => {   
            this.form = { 
              id: response.data.id,
              cost_of_sales: response.data.cost_of_sales,
              cost_of_sales_method: response.data.cost_of_sales_method,
              cost_of_production: response.data.cost_of_production,
              cost_of_production_method: response.data.cost_of_production_method,
            };   
        })
        .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
        });
    },
    saveData(){
      this.isProgressing = true;
      const params = this.form;
      params.session_id = this.$getUser().session_id;
      const that = this;     
      axios.post('/api/CostsSettings/UpdateCostSettings', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null && response.data.length == 36){  
                this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
            }
            
        })
        .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
        })
        .finally(() => { 
            setTimeout(() => {
                that.isProgressing = false;
            }, 500);
        }); 
      },
      async helpPageViewIcon(){
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/CostsManagementHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
        }, 
    }, 
    created() {
        this.helpPageViewIcon();
        this.getData();
    }
}; 
</script>